import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDeleteGameListModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  gameTitle: string;
}

const ConfirmDeleteGameListModal = ({
  show,
  onHide,
  onConfirm,
  gameTitle,
}: ConfirmDeleteGameListModalProps) => {
  return (
    <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Deletion</DialogTitle>

      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove <strong>{gameTitle}</strong> from your
          game list?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteGameListModal;
